export const mediaErrorCodes = {
  LAYOUT_EXPIRED: 4200
};
